import { StateCreator } from 'zustand';
import { AuthSlice, RootStore } from 'stores/pet-profile-new/types';

export const INIT_CUSTOMER_ID = null;

// TODO: should we add fetch cache per customer id?
export const authSlice: StateCreator<RootStore, [], [], AuthSlice> = (set, get) => ({
  customerId: INIT_CUSTOMER_ID,
  isLoggedIn: false,

  // should be called only when we have a real customer id
  setCustomerId: async ({ customerId, refetchProfiles = true }) => {
    set((store) => {
      const id = String(customerId);
      const isCustomerExist = store.profilesPerCustomer[id];
      return {
        customerId, // it is number
        isLoggedIn: true,
        // in case there is no such customer in the store yet it will add it
        profilesPerCustomer: isCustomerExist
          ? store.profilesPerCustomer
          : { ...store.profilesPerCustomer, [id]: [] }, // id is string
      };
    });

    if (refetchProfiles) {
      const { fetchPetProfiles } = get();
      await fetchPetProfiles(customerId);
    }
  },

  setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
});
